import { WheelRaffleItemStatus } from "./types";
import type { Raffle, RaffleBase } from "./types";
import { getCompletionPercent } from "./completionPercent";
import type { RaffleRole } from "./selectHistory";

export type RaffleBadge = RaffleRole | "won";

export type RaffleBadgeSource = Pick<RaffleBase, "my_prize_usdt"> &
  Partial<Pick<RaffleBase, "is_winner" | "status">> &
  // completion есть в promos / search / detail; в recent и превью — нет.
  Partial<Pick<Raffle, "completion">>;

// Выигрыш важнее роли: его зритель ищет в списке в первую очередь.
export const getRaffleBadge = (
  raffle: RaffleBadgeSource,
  role: RaffleRole | null,
): RaffleBadge | null =>
  raffle.is_winner || raffle.my_prize_usdt ? "won" : role;

// Без бейджа показываем, насколько выполнены условия. Когда они выполнены,
// бэк ставит is_participant — и вместо прогресса появляется Joined.
export const getCardProgress = (raffle: RaffleBadgeSource): number | null => {
  if (!raffle.completion) return null;
  if (raffle.status === WheelRaffleItemStatus.DRAWN) return null;
  return getCompletionPercent(raffle.completion);
};
